module.exports = __webpack_public_path__ + "img/landing-logo-variant-B.7c205157.png";